import { LoginResponse } from '../models/login';
import { RoleId } from '../common-enums/enum';

export const breadCrumbUrl: Record<string, string[]> = {
  '/fresh/transaction/Purchase': ['Home', 'Transactions'],
  '/fresh/transaction/SIP': ['Home', 'Transactions'],
  '/fresh/transaction/STP': ['Home', 'Transactions'],
  '/fresh/transaction/SWP': ['Home', 'Transactions'],
  '/fresh/transaction/Switch%20out': ['Home', 'Transactions'],
  '/transaction/Purchase': ['Home', 'Transactions'],
  '/transaction/Redeem': ['Home', 'Transactions'],
  '/reports': ['Home', 'Reports'],
  '/reports/portfolio-valuation-report': ['Home', 'Reports'],
  '/reports/capital-gain-realized-report': ['Home', 'Reports'],
  '/reports/transactions': ['Home', 'Reports'],
  '/reports/sao': ['Home', 'Reports'],
  '/portfolio-valuation-summary-report': [
    'Home',
    'Reports',
    'Portfolio Valuation Summary Report'
  ],
  '/portfolio-valuation-detail-report': [
    'Home',
    'Reports',
    'Portfolio Valuation Detail Report'
  ],
  '/capital-gain-realized-report': [
    'Home',
    'Reports',
    'Capital Gain Realized Report'
  ],
  '/capital-gain-summary-report': [
    'Home',
    'Reports',
    'Capital Gain Summary Report'
  ],
  '/capital-gain-detailed-report': [
    'Home',
    'Reports',
    'Capital Gain Detail Report'
  ],
  '/transaction-summary-report': [
    'Home',
    'Reports',
    'Transaction Summary Report'
  ],
  '/client/client-onboarding': ['Home', 'Client Onboarding'],
  '/client/client-onboarding?mode=complete': ['Home', 'Create UCC'],
  '/client/new-client-onboarding': ['Client', 'Add Client'],
  '/client/edit-client-details': ['Client', 'Details', 'Edit Client'],
  '/broker/profile': ['Home', 'Brokers', 'Broker Profile'],
  '/advisor/profile': ['Home', 'Advisors', 'Advisor Profile'],
  '/relationshipManager/profile': [
    'Home',
    'Relationship Managers',
    'RM Profile'
  ],
  '/relationshipManager/clients': ['Home', 'Clients'],
  '/broker/reviewRequest': ['Home', 'Review Request'],
  '/advisor/reviewRequest': ['Home', 'Review Request'],
  '/broker/brokers-list': ['Home', 'Brokers'],
  '/broker/brokers-list?tab=brokers': ['Home', 'Brokers'],
  '/broker/brokers-list?tab=rm': ['Home', 'Relationship Managers'],
  '/advisor/advisors-list': ['Home', 'Advisors'],
  '/advisor/advisors-list?tab=advisors': ['Home', 'Advisors'],
  '/advisor/advisors-list?tab=rm': ['Home', 'Relationship Managers'],

  '/broker/relationship-manager': ['Home', 'Relationship Managers'],
  '/advisor/relationship-manager': ['Home', 'Relationship Managers'],
  '/relationshipManager/onboard-rm': [
    'Home',
    'Relationship Managers',
    'Add RM'
  ],
  '/advisor/onboard-rm': ['Home', 'Relationship Managers', 'Add RM'],
  '/broker/onboard-broker': ['Home', 'Brokers', 'Add Broker'],
  '/advisor/onboard-advisor': ['Home', 'Advisors', 'Add Advisor'],
  '/broker/clients': ['Home', 'Clients'],
  '/advisor/clients': ['Home', 'Clients'],

  // Product Admin
  '/product-admin/dashboard': ['Home', 'Dashboard'],
  '/product-admin/member-onboarding': ['Home', 'Add New Member'],
  '/product-admin/dbf-file-viewer': ['Home', 'Data File Viewer'],

  // Market Watch
  '/broker/market-watch': ['Home', 'Market Watch'],
  '/advisor/market-watch': ['Home', 'Market Watch'],
  '/relationshipManager/market-watch': ['Home', 'Market Watch'],
  '/market-watch': ['Home', 'Market Watch'],

  // Scheme Analytics
  '/broker/scheme-analytics': ['Home', 'Scheme Analytics'],
  '/advisor/scheme-analytics': ['Home', 'Scheme Analytics'],
  '/relationshipManager/scheme-analytics': ['Home', 'Scheme Analytics'],
  '/scheme-analytics': ['Home', 'Scheme Analytics'],

  // Scheme Details
  '/broker/scheme-details': ['Home', 'Scheme Analytics'],
  '/advisor/scheme-details': ['Home', 'Scheme Analytics'],
  '/relationshipManager/scheme-details': ['Home', 'Scheme Analytics'],
  '/scheme-details': ['Home', 'Scheme Analytics'],

  // Transaction History
  '/broker/transaction-history': ['Home', 'Transaction History'],
  '/advisor/transaction-history': ['Home', 'Transaction History'],

  // Create UCC
  '/broker/create-ucc': ['Home', 'Create UCC'],
  '/advisor/create-ucc': ['Home', 'Create UCC'],
  '/relationshipManager/create-ucc': ['Home', 'Create UCC'],

  // Client Portfolio breadcrumb
  '/client-portfolio': ['Home', 'Clients', 'Client Portfolio'],
  '/client-portfolio/:id': ['Home', 'Clients', 'Client Portfolio'],
  '/client-portfolio/:id/:role': ['Home', 'Clients', 'Client Portfolio'],
  '/broker-portfolio/:id': ['Home', 'Clients', 'Client Portfolio'],

  // Client Routes
  '/client/edit-details': ['Client', 'Edit Client'],
  '/client/profile': ['Client', 'Profile'],
  '/client/holdings': ['Client', 'Holdings'],
  '/client/transactions': ['Client', 'Transactions'],
  '/client/riskprofile': ['Client', 'Risk Profile'],
  '/client/riskprofileresult': ['Client', 'Risk Profile Result'],

  // Transaction Routes
  '/transaction': ['Home', 'Transactions'],

  // Risk Profile
  '/risk-profile': ['Home', 'Risk Profile'],
  '/risk-profile-result': ['Home', 'Risk Profile Result'],
  '/broker-client-risk-profile-component': ['Home', 'Risk Profile'],
  '/risk-profile-form': ['Home', 'Risk Profile Form'],

  // Reports
  '/broker/report': ['Home', 'Reports'],
  '/advisor/report': ['Home', 'Reports'],
  '/relationshipManager/report': ['Home', 'Reports'],

  // UCC List
  '/broker/ucc-list': ['Home', 'UCC List'],
  '/advisor/ucc-list': ['Home', 'UCC List'],
  '/relationshipManager/ucc-list': ['Home', 'UCC List'],

  // Mandate
  '/broker/mandate': ['Home', 'Mandate List'],
  '/advisor/mandate': ['Home', 'Mandate List'],
  '/relationshipManager/mandate': ['Home', 'Mandate List'],
  '/client/mandate': ['Home', 'Mandate List']
};
export const headerByUrl: Record<string, string> = {
  '/broker/dashboard': 'Home',
  '/advisor/dashboard': 'Home',
  '/relationshipManager/dashboard': 'Home',
  '/fresh/transaction/Purchase': 'Transactions',
  '/fresh/transaction/SIP': 'Transactions',
  '/fresh/transaction/STP': 'Transactions',
  '/fresh/transaction/SWP': 'Transactions',
  '/fresh/transaction/Switch%20out': 'Transactions',
  '/transaction/Purchase': 'Transactions',
  '/transaction/Redeem': 'Transactions',
  '/reports': 'Portfolio Valuation Report',
  '/reports/portfolio-valuation-report': 'Portfolio Valuation Report',
  '/reports/sao': 'SOA Download',
  '/reports/capital-gain-realized-report': 'Capital Gain Realized Report',
  '/reports/transactions': 'Transactions',
  '/portfolio-valuation-summary-report': 'Portfolio Valuation Summary Report',
  '/portfolio-valuation-detail-report': 'Portfolio Valuation Detail Report',
  '/capital-gain-realized-report': 'Capital Gain Realized Report',
  '/capital-gain-summary-report': 'Capital Gain Summary Report',
  '/capital-gain-detailed-report': 'Capital Gain Detail Report',
  '/transaction-summary-report': 'Transaction Summary Report',
  '/client/client-onboarding': 'Client Onboarding',
  '/client/client-onboarding?mode=complete': 'Complete Profile',
  '/broker/profile': 'Broker Profile',
  '/advisor/profile': 'Advisor Profile',
  '/relationshipManager/profile': 'RM Profile',
  '/broker/reviewRequest': 'Review Request',
  '/advisor/reviewRequest': 'Review Request',
  '/broker/brokers-list': 'Brokers',
  '/broker/brokers-list?tab=brokers': 'Brokers',
  '/broker/brokers-list?tab=rm': 'Relationship Managers',
  '/advisor/advisors-list': 'Advisors',
  '/advisor/advisors-list?tab=advisors': 'Advisors',
  '/advisor/advisors-list?tab=rm': 'Relationship Managers',
  // '/advisor/advisors-rms-management': 'Advisors',
  '/broker/relationship-manager': 'Relationship Managers',
  '/advisor/relationship-manager': 'Relationship Managers',
  '/relationshipManager/onboard-rm': 'Add RM',
  '/advisor/onboard-rm': 'Add RM',
  '/broker/onboard-broker': 'Add Broker',
  '/advisor/onboard-advisor': 'Add Advisor',

  '/broker/clients': 'Clients',
  '/advisor/clients': 'Clients',
  '/relationshipManager/clients': 'Clients',

  // Product Admin
  '/product-admin/dashboard': 'Admin',
  '/product-admin/member-onboarding': 'Add New Member',

  // Market Watch
  '/broker/market-watch': 'Market Watch',
  '/advisor/market-watch': 'Market Watch',
  '/relationshipManager/market-watch': 'Market Watch',
  '/market-watch': 'Market Watch',

  // Scheme Analytics
  '/broker/scheme-analytics': 'Scheme Analytics',
  '/advisor/scheme-analytics': 'Scheme Analytics',
  '/relationshipManager/scheme-analytics': 'Scheme Analytics',
  '/scheme-analytics': 'Scheme Analytics',

  // Scheme Details
  '/broker/scheme-details': 'Scheme Details',
  '/advisor/scheme-details': 'Scheme Details',
  '/relationshipManager/scheme-details': 'Scheme Details',
  '/scheme-details': 'Scheme Details',

  // Transaction History
  '/broker/transaction-history': 'Transaction History',
  '/advisor/transaction-history': 'Transaction History',

  // Create UCC
  '/broker/create-ucc': 'Create UCC',
  '/advisor/create-ucc': 'Create UCC',
  '/relationshipManager/create-ucc': 'Create UCC',

  // Reports
  '/broker/report': 'Reports',
  '/advisor/report': 'Reports',
  '/relationshipManager/report': 'Reports',

  // Mandate routes
  '/broker/mandate': 'Mandate List',
  '/advisor/mandate': 'Mandate List',
  '/relationshipManager/mandate': 'Mandate List',
  '/client/mandate': 'Mandate List',

  // Client Profile routes
  '/broker/client-profile': 'Client Profile',
  '/advisor/client-profile': 'Client Profile',
  '/relationshipManager/client-profile': 'Client Profile',

  // Client Portfolio routes
  '/client-portfolio': 'Client Portfolio',
  '/broker-portfolio': 'Client Portfolio',

  // Client Routes
  '/client/edit-details': 'Edit Client',
  '/client/profile': 'Client Profile',
  '/client/holdings': 'Holdings',
  '/client/transactions': 'Transactions',
  '/client/riskprofile': 'Risk Profile',
  '/client/riskprofileresult': 'Risk Profile Result',

  // Transaction Routes
  '/transaction': 'Transactions',

  // Risk Profile
  '/risk-profile': 'Risk Profile',
  '/risk-profile-result': 'Risk Profile Result',
  '/broker-client-risk-profile-component': 'Risk Profile',
  '/risk-profile-form': 'Risk Profile Form'
};

let userDetails: LoginResponse | null = null;
const storedRoleDetails = localStorage.getItem('roleDetails');
if (storedRoleDetails) {
  userDetails = JSON.parse(storedRoleDetails) as LoginResponse;
}

if (userDetails?.newRoleFinal?.roleId === RoleId.Advisor) {
  // breadCrumbUrl['/broker/brokers-list'] = ['Home', 'Advisors'];
  breadCrumbUrl['/advisor/advisors-list'] = ['Home', 'Advisors'];
  // breadCrumbUrl['/advisor/advisors-rms-management'] = ['Home', 'Advisors'];
}

// Mapping for breadcrumb navigation - maps breadcrumb text to actual route
// Note: Some breadcrumbs (Brokers, Relationship Managers, Advisors, and profile breadcrumbs)
// are handled dynamically in the breadcrumb component based on user role
export const breadcrumbNavigationMap: Record<string, string> = {
  'Scheme Analytics': '/scheme-analytics'
};

export const BREAD_CRUMB = {
  MAIN_HEADING: 'Home'
};
